import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

export interface AlertComponentProps {
  type: 'success' | 'info' | 'warning' | 'error';
  message: string;
  onClose?(): void;
}

const Alert: React.FC<AlertComponentProps> = ({
  type,
  message,
  onClose,
  ...rest
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    if (onClose) onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={handleClose}
    >
      <MuiAlert onClose={handleClose} elevation={6} severity={type} {...rest}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Alert;
